import { motion } from "framer-motion";

const AboutTestimonials = ({
    testimonials,
}) => {
    return (
        <section className="py-20 bg-[#f7f7f7]">
            <div className="max-w-6xl mx-auto px-6 text-center">
                <h2 className="text-3xl font-bold mb-12">
                    Khách hàng nói về chúng tôi
                </h2>

                <div className="grid md:grid-cols-3 gap-8">
                    {testimonials.map(
                        (item, index) => (
                            <motion.div
                                key={item.name}
                                className="bg-white p-6 rounded-xl shadow-md"
                                initial={{
                                    opacity: 0,
                                    y: 20,
                                }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}
                                transition={{
                                    duration: 0.6,
                                    delay: index * 0.2,
                                }}
                            >
                                <p className="italic mb-4">
                                    "{item.content}"
                                </p>

                                <div className="font-semibold">
                                    {item.name}
                                </div>
                            </motion.div>
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default AboutTestimonials;